<template>
	<a-page-header
		style="border: 1px solid rgb(235, 237, 240);"
		:title="'User Account'"
		@back="() => $router.go(-1)"
	>
	</a-page-header>
</template>

<script>
export default {
	components: {},
}
</script>

<style></style>
